(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@material/banner", [], factory);
	else if(typeof exports === 'object')
		exports["banner"] = factory();
	else
		root["mdc"] = root["mdc"] || {}, root["mdc"]["banner"] = factory();
})(this, function() {
return 